import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";

interface TariffBreadcrumbsProps {
  companyName: string;
}

const TariffBreadcrumbs = ({ companyName }: TariffBreadcrumbsProps) => {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 pb-4 sm:pb-6 relative z-20 overflow-x-auto">
      <Breadcrumb>
        <BreadcrumbList className="flex-nowrap whitespace-nowrap">
          <BreadcrumbItem className="inline-flex">
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator className="shrink-0" />
          <BreadcrumbItem className="inline-flex">
            <BreadcrumbLink asChild>
              <Link to="/tarifwissen">Tarifwissen</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator className="shrink-0" />
          <BreadcrumbItem className="inline-flex">
            <BreadcrumbPage className="truncate max-w-[200px] sm:max-w-none">{companyName} Cyberversicherung</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default TariffBreadcrumbs;
